import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Layout,
  Input,
  Row,
  Col,
  Tag,
  BackTop,
  Skeleton,
  Empty,
  message,
} from "antd";
import "./index.scss";
import _ from "lodash"; // 引入lodash来使用_.debounce
import tool from "@/assets/tool";
import axiosInstance from "@/axios/axiosInstance";
import { setupWechatShare, updateMetaTags } from "@/utils/shareConfig";
import { video_bq } from "@/assets/jfData";
const { Search } = Input;

const { Header, Content, Footer } = Layout;

const VideoList = () => {
  const [neicTag, setneicTag] = useState("");
  const [videoList, setVideoList] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [searchTitle, setSearchTitle] = useState(""); // 添加搜索关键词状态
  const pageSize = 20; // 每页加载数量
  const containerRef = useRef(null);

  const handleTNeicClick = (tag) => {
    setneicTag(tag.key);
    setPage(1); // 重置页码
    setVideoList([]); // 清空现有列表
    setHasMore(true); // 重置加载状态
    fetchVideoData(1, tag.key, searchTitle); // 重新搜索
  };

  useEffect(() => {
    fetchVideoData(1);

    // 设置分享配置
    setupWechatShare({
      title:
        "渐风AI,AI技术视频教程,AI视频课,大模型开发,LLMs开发视频,人工智能学习网",
      desc: "渐风AI,AI技术视频教程,AI视频课,大模型开发,LLMs开发视频,人工智能学习网",
    });

    // 更新meta标签
    updateMetaTags(
      "渐风AI,AI技术视频教程,AI视频课,大模型开发,LLMs开发视频,人工智能学习网",
      "渐风AI,AI技术视频教程,AI视频课,大模型开发,LLMs开发视频,人工智能学习网"
    );
    document.title =
      "渐风AI,AI技术视频教程,AI视频课,大模型开发,LLMs开发视频,人工智能学习网";
  }, []);

  const fetchVideoData = async (
    pageNum,
    label = neicTag,
    title = searchTitle
  ) => {
    if (loading || (!hasMore && pageNum > 1)) return;

    try {
      setLoading(true);
      const params = {
        page: pageNum,
        limit: pageSize,
        title: title.trim(), // 添加标题搜索
      };

      if (label) {
        params.label = label;
      }

      const response = await axiosInstance.get(`/video/page/list`, { params });

      const newData = response.data.data || [];
      const totalCount = response.data.page.totalCount;

      if (pageNum === 1) {
        setVideoList(newData);
      } else {
        setVideoList((prev) => [...prev, ...newData]);
      }

      setTotal(totalCount);
      const currentTotal =
        pageNum === 1 ? newData.length : videoList.length + newData.length;
      setHasMore(currentTotal < totalCount);
    } catch (error) {
      console.error("Error fetching video data:", error);
      message.error("加载视频数据失败，请稍后重试");
    } finally {
      setLoading(false);
    }
  };

  const handleScroll = useCallback(() => {
    if (!containerRef.current || loading || !hasMore) return;

    const container = containerRef.current;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    if (documentHeight - (scrollTop + windowHeight) < 100) {
      // 检查是否已经加载了所有数据
      if (videoList.length < total) {
        setPage((prev) => prev + 1);
        fetchVideoData(page + 1);
      }
    }
  }, [loading, hasMore, page, videoList.length, total]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  const debouncedFetchData = _.debounce(fetchVideoData, 1000);
  const handleChange = (e) => {
    debouncedFetchData(1);
  };

  // 处理搜索
  const handleSearch = (value) => {
    setSearchTitle(value);
    setPage(1);
    setVideoList([]);
    setHasMore(true);
    fetchVideoData(1, neicTag, value);
  };

  // 防抖处理搜索
  const debouncedSearch = useCallback(
    _.debounce((value) => {
      handleSearch(value);
    }, 500),
    []
  );

  // 处理输入变化
  const handleInputChange = (e) => {
    const value = e.target.value;
    debouncedSearch(value);
  };

  const neitagOptions = video_bq.map((tag) => (
    <Tag
      color={neicTag === tag.key ? "blue" : "default"}
      key={tag.key}
      onClick={() => handleTNeicClick(tag)}
    >
      {tag.value}
    </Tag>
  ));

  const toDetail = (record) => {
    const params = new URLSearchParams({
      id: record.videoId,
      profilePictureUrl: record.profilePictureUrl,
      nickName: record.nickName,
    });
    const url = `/video_detail?${params.toString()}`;
    window.open(url, "_blank");
  };

  const getLabel = (l) => {
    const bq = video_bq;
    let label = bq.find((v) => v.key == l)?.value;
    return label || "暂无标签";
  };

  const sectionStyle = (v) => ({
    backgroundImage: `url(${v.cover})`,
    backgroundRepeat: "no-repeat",
    color: "#fff",
    backgroundSize: "cover",
  });

  const renderVideoBlocks = () => {
    return videoList.map((v, index) => {
      return (
        <Col
          xs={24}
          sm={12}
          md={8}
          lg={6}
          key={index}
          className="video-col"
          onClick={() => toDetail(v)}
        >
          <div className="video-container" style={sectionStyle(v)}>
            <div className="title child aiTitle" title={v.title}>
              {v.title}
            </div>
          </div>
          <div className="video-fot">
            <div className="user-info">
              <img
                src={`/file/${v.profilePictureUrl}`}
                alt=""
                className="avatar"
              />
              <span className="nickName">
                {v.nickName || tool.hideMiddleFour(v.phone)}
              </span>
              <span className="date">{v.createTime.split(" ")[0]}</span>
            </div>
            <div className="label-container">
              <span className={`label_${v.label}`}>{getLabel(v.label)}</span>
            </div>
          </div>
        </Col>
      );
    });
  };

  return (
    <div className="video-tutorials" ref={containerRef}>
      <Layout className="videolist">
        <Header className="videolist-hea">
          <div className="header-content">
            <div className="name">教程视频</div>
            <Input
              placeholder="搜索视频标题"
              allowClear
              onChange={handleInputChange}
              onSearch={handleSearch}
              className="search-input"
              enterButton
            />
          </div>
        </Header>

        <Content className="vio-cont">
          <div className="name">专业类型</div>
          <div className="tag-container">{neitagOptions}</div>
        </Content>

        <Footer style={{ background: "#f5f5f5" }}>
          <Row gutter={[16, 16]}>
            {loading && page === 1 ? (
              <Col span={24} key="skeleton-placeholder">
                <Skeleton active paragraph={{ rows: 4 }} />
              </Col>
            ) : videoList.length ? (
              <>
                {renderVideoBlocks()}
                {loading && (
                  <Col span={24}>
                    <div className="loading-more">
                      <Skeleton active paragraph={{ rows: 1 }} />
                    </div>
                  </Col>
                )}
                {!hasMore && (
                  <Col span={24}>
                    <div className="no-more">
                      {videoList.length === 0 ? "暂无相关视频" : "已经到底了"}
                    </div>
                  </Col>
                )}
              </>
            ) : (
              <Col span={24} style={{ textAlign: "center", padding: "40px 0" }}>
                <Empty
                  description={
                    searchTitle
                      ? `未找到包含"${searchTitle}"的视频`
                      : "暂无相关视频"
                  }
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                />
              </Col>
            )}
          </Row>
        </Footer>
      </Layout>
      <BackTop />
    </div>
  );
};

export default VideoList;
